export const observationsTable = [
  {
    id: 3,
    label: 'Observation Files',
    intlKey: 'table.observation_files'
  },
  {
    id: 2,
    label: 'Observation note',
    intlKey: 'table.observation_note'
  }
]
